import React from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import AccordionContext from './AccordionContext';
import { AccordionElement } from './AccordionElements';
import { AccordionVariant } from './types';
export var Accordion = React.forwardRef(function (_a, fRef) {
    var id = _a.id, className = _a.className, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? '' : _b, _c = _a.variant, variant = _c === void 0 ? AccordionVariant.Inline : _c, _d = _a.numbered, numbered = _d === void 0 ? false : _d, children = _a.children;
    var borderWidth = variant === AccordionVariant.FullPage ? '0px 0px 1px 0px' : '1px';
    var borderRadius = variant === AccordionVariant.FullPage ? '0px' : '8px';
    return (React.createElement(InternalProvider, null,
        React.createElement(AccordionContext.Provider, { value: { numbered: numbered } },
            React.createElement(AccordionElement, { id: id, "aria-label": ariaLabel, className: className, ref: fRef, style: { borderWidth: borderWidth, borderRadius: borderRadius }, "$variant": variant }, children))));
});
